import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'order-to-seat'
  },
  {
    path: 'order-to-seat',
    loadChildren: () => import('./features/order-to-seat/ots.routes').then(m => m.otsRoutes)
  }
];
